<div class="center-modal">
	<div class="close" (click)="close()"></div>
	<div class="modal-container">
		<h1>{{'Delete service' | translate}}</h1>
		<h3>{{call.description}}</h3>
		<form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
			<div class="L-12 M-12 S-12 columns TextCentered">
				<input name="sumbit" type="submit" value="{{'Confirm' | translate}}">
			</div>
			<div class="L-12 M-12 S-12 columns TextCentered">
				<a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
			</div>

		</form>
	</div>
</div>